// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mobile-success-dialog-container {
  padding-top: 24px;
  padding-bottom: 24px;
}
.mobile-success-dialog-container .dialog-title {
  font-size: 1.5rem;
  font-weight: bold;
}
.mobile-success-dialog-container .dialog-title .checkmark {
  color: #6DD378;
}
.mobile-success-dialog-container .dialog-content {
  font-size: 16px;
  padding-bottom: 0px;
}
.mobile-success-dialog-container .dialog-content p {
  margin-bottom: 10px;
}
.mobile-success-dialog-container .dialog-actions {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  padding-left: 24px;
  padding-right: 24px;
}
.mobile-success-dialog-container .dialog-actions .ctaButton {
  background-color: #866dff;
  border: 1px solid #866dff;
  border-radius: 4px;
  box-shadow: none !important;
  line-height: 1.2;
}
.mobile-success-dialog-container .dialog-actions .ctaButton .mdc-button__label {
  color: #fff;
  line-height: 40px !important;
  font-size: 14px;
  font-family: "Roboto", sans-serif;
  text-align: center;
  font-weight: 500;
  letter-spacing: 1.2px;
  text-transform: uppercase;
}

.modal-body {
  color: #777183;
}
.modal-body .icon {
  font-weight: bold;
  font-size: 24px;
  color: gray;
}
.modal-body em {
  font-style: italic;
}
.modal-body strong {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/registration/mobile-success-dialog/mobile-success-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,oBAAA;AACF;AACE;EACE,iBAAA;EACA,iBAAA;AACJ;AAAI;EACE,cAAA;AAEN;AAEE;EACE,eAAA;EAEA,mBAAA;AADJ;AAEI;EACE,mBAAA;AAAN;AAIE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAFJ;AAGI;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,gBAAA;AAFN;AAII;EACE,WAAA;EACA,4BAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;AAFN;;AAQA;EACE,cAAA;AALF;AAOE;EACE,iBAAA;EACA,eAAA;EACA,WAAA;AALJ;AAQE;EACE,kBAAA;AANJ;AASE;EACE,iBAAA;AAPJ","sourcesContent":[".mobile-success-dialog-container {\n  padding-top: 24px;\n  padding-bottom: 24px;\n\n  .dialog-title {\n    font-size: 1.5rem;\n    font-weight: bold;\n    .checkmark {\n      color: #6DD378; // Green checkmark, adjust as needed\n    }\n  }\n\n  .dialog-content {\n    font-size: 16px;\n    // margin-bottom: 20px;\n    padding-bottom: 0px;\n    p {\n      margin-bottom: 10px;\n    }\n  }\n\n  .dialog-actions {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: flex-end;\n    padding-left: 24px;\n    padding-right: 24px;\n    .ctaButton {\n      background-color: #866dff;\n      border: 1px solid #866dff;\n      border-radius: 4px;\n      // margin: 32px 10px 0px;\n      box-shadow: none !important;\n      line-height: 1.2;\n  \n    .mdc-button__label {\n      color: #fff;\n      line-height: 40px !important;\n      font-size: 14px;\n      font-family: \"Roboto\", sans-serif;\n      text-align: center;\n      font-weight: 500;\n      letter-spacing: 1.2px;\n      text-transform: uppercase;\n    }\n  }\n  }\n} \n\n.modal-body {\n  color: #777183;\n\n  .icon {\n    font-weight: bold;\n    font-size: 24px;\n    color: gray;\n  }\n\n  em {\n    font-style: italic;\n  }\n\n  strong {\n    font-weight: bold;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
